import { useAppSelector } from "store/store";
import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";

import { useState } from "react";
import moment from "moment";
import { CalendarHeader } from "./CalendarHeader";
import { CalendarGrid } from "./CalendarGrid";
import CalendarNavbar from "./CalendarNavbar";

export default function Calendar() {
  const { token } = useAppSelector((state) => state.auth);
  //*===============Variable==================
  const [currentView, setCurrentView] = useState<"week" | "month" | "day">("week");
  const [direction, setDirection] = useState<"left" | "right">("right");
  const [currentDate, setCurrentDate] = useState(moment());
  const [selectedDate, setSelectedDate] = useState(moment());
  const getDays = () => {
    if (currentView === "day") {
      return [currentDate.clone()];
    }
    if (currentView === "week") {
      const startOfWeek = currentDate.clone().startOf("week"); // Sunday
      return Array.from({ length: 7 }, (_, i) => startOfWeek.clone().add(i, "day"));
    }

    // month view
    const startOfWeek = currentDate.clone().startOf("week"); // Sunday
    return Array.from({ length: 7 }, (_, i) => startOfWeek.clone().add(i, "day"));
    // const startOfMonth = currentDate.clone().startOf("month").startOf("week");
    // return Array.from({ length: 42 }, (_, i) => startOfMonth.clone().add(i, "day")); // 6 weeks
  };
  const days = getDays();
  return (
    <BusinessSuiteContentLayout>
      <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
        <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
          <div className="text-start lg:w-auto md:w-auto w-full">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Calendar</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Smart Scheduling, Attendance, and Performance Tracking</p>
          </div>
          <CalendarNavbar />
        </div>
      </div>
      <div className="w-full mt-5 ">
        <div className="w-full mx-auto bg-white shadow rounded-lg">
          <CalendarHeader setDirection={setDirection} currentView={currentView} setCurrentView={setCurrentView} currentDate={currentDate} setCurrentDate={setCurrentDate} />
          {/* <CalendarGrid date={currentDate} selectedDate={selectedDate} setSelectedDate={setSelectedDate} /> */}
          <CalendarGrid days={days} date={currentDate} setCurrentView={setCurrentView} currentView={currentView} direction={direction} />
        </div>
      </div>
    </BusinessSuiteContentLayout>
  );
}
